module.exports = __webpack_public_path__ + "img/online-course.8abad234.svg";